var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8067_4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 7.49992C8.33203 7.01077 8.51447 6.69795 8.75399 6.49472C9.01163 6.27612 9.38483 6.14575 9.79037 6.14575C10.1959 6.14575 10.5691 6.27612 10.8267 6.49472C11.0663 6.69795 11.2487 7.01077 11.2487 7.49992C11.2487 7.86422 11.1629 8.06648 11.0631 8.21605C10.9468 8.39056 10.7937 8.52818 10.5348 8.7609L10.4829 8.80759C10.2166 9.04729 9.86617 9.37133 9.59901 9.84333C9.32367 10.3297 9.16536 10.9175 9.16536 11.6666C9.16536 12.1268 9.53846 12.4999 9.9987 12.4999C10.4589 12.4999 10.832 12.1268 10.832 11.6666C10.832 11.1657 10.9341 10.868 11.0494 10.6643C11.1729 10.4462 11.3433 10.2755 11.5978 10.0464C11.6207 10.0258 11.6449 10.0043 11.6701 9.98182C11.8978 9.77883 12.2097 9.50079 12.4499 9.14056C12.7408 8.70419 12.9154 8.17728 12.9154 7.49992C12.9154 6.53073 12.5249 5.74981 11.905 5.22387C11.3033 4.7133 10.5307 4.47909 9.79037 4.47909C9.05006 4.47909 8.27744 4.7133 7.6757 5.22387C7.05584 5.74981 6.66536 6.53073 6.66536 7.49992C6.66536 7.96016 7.03846 8.33325 7.4987 8.33325C7.95894 8.33325 8.33203 7.96016 8.33203 7.49992Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6236 15.5597C10.9332 15.2191 10.9081 14.6921 10.5676 14.3825C10.2271 14.0729 9.70003 14.098 9.39043 14.4385L9.3821 14.4477C9.0725 14.7882 9.09758 15.3153 9.43812 15.6249C9.77866 15.9345 10.3057 15.9094 10.6153 15.5688L10.6236 15.5597Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9987 0.833252C4.93596 0.833252 0.832031 4.93718 0.832031 9.99992C0.832031 15.0627 4.93596 19.1666 9.9987 19.1666C15.0614 19.1666 19.1654 15.0627 19.1654 9.99992C19.1654 4.93718 15.0614 0.833252 9.9987 0.833252ZM2.4987 9.99992C2.4987 5.85766 5.85644 2.49992 9.9987 2.49992C14.141 2.49992 17.4987 5.85766 17.4987 9.99992C17.4987 14.1422 14.141 17.4999 9.9987 17.4999C5.85644 17.4999 2.4987 14.1422 2.4987 9.99992Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8067_4223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e404a4ec72735f6ba9546bb04e40629c.svg";
export { ForwardRef as ReactComponent };